import { NavLink, useParams } from "react-router-dom";
import { AntentIndicator, LeftArrow } from "src/components/svg";
import { Channel } from "src/models";
import { _ } from "src/services";

export const TvChannelCardMobile: React.FC<Channel> = ({ slug, thumbnail, logo, title }) => {

    const { slug: routeSlug }: any = useParams();

    return (
        <NavLink className="card-channel center mx-auto my-3 d-block" activeClassName="selected-channel" to={`/tv/${slug}`}>
            {
                slug.toLowerCase().trim() === ("" + routeSlug).toLowerCase().trim() &&
                <span className="indicator-current justify-content-center align-content-center d-flex">
                    <AntentIndicator />
                </span>
            }
            <div className="channel-item">
                <div style={{ backgroundImage: `url(${thumbnail})` }} className="channel-thumbnail" />
                <div className="channel-details justify-content-center align-content-center center">
                    <div className="m-auto text-center">
                        <h1 className="channel-name d-inline-block mr-1">{title}</h1>
                        <div style={{ backgroundImage: `url(${logo})` }} className="channel-logo d-inline-block" />
                    </div>
                    <div className="programs-list-link m-auto text-center">
                        <span className="d-inline-block vertical-align-middle left-arrow" >
                            <LeftArrow />
                        </span>
                        <span className="d-inline-block vertical-align-middle ml-1">{_("programList")}</span>
                    </div>
                </div>
            </div>
        </NavLink>
    );
};